import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { FaPhone, FaSearch } from "react-icons/fa";
import { Modal, Button, Toast, ToastContainer } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const NotificationPage = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [occasionFilter, setOccasionFilter] = useState("All Occasions");

  const [showModal, setShowModal] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [wishMessage, setWishMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [readNotifications, setReadNotifications] = useState(new Set());

  // Logs
  const [activeTab, setActiveTab] = useState("All");
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [showLogModal, setShowLogModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [logs, setLogs] = useState([]);

  // unread
  const unreadCount = logs.filter((log) => !readNotifications.has(log.notificationId)).length;
  const markAsRead = (notificationId) =>
    setReadNotifications((prev) => new Set([...prev, notificationId]));
  const markAllAsRead = () =>
    setReadNotifications(new Set(logs.map((log) => log.notificationId)));

  const handleWishClick = (person) => {
    setSelectedPerson(person);
    const defaultMessage = `Send Custom message`;
    setWishMessage(defaultMessage);
    setShowModal(true);
  };

  const handleSendMessage = async (person, message) => {
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/v1/notification/send-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: message,
          phone: person.customerPhone,
          agentId: person.agentId,
          policyId: person._id || null,
        }),
      });

      fetchNotification();
      if (!res.ok) throw new Error("Failed to send notification");
      alert("✅ Message sent successfully!");
    } catch (error) {
      alert("❌ Failed to send notifications");
      console.log(error);
    }
  };

  // customers
  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const agent = user || JSON.parse(localStorage.getItem("user"));
        if (!agent?.id) return console.warn("❌ Agent ID not found.");

        const customerList = await fetch(`${import.meta.env.VITE_API_URL}/api/agent/${agent.id}`);
        const data = await customerList.json();
        if (customerList.ok && Array.isArray(data)) {
          setCustomers(data);
          setFilteredCustomers(data);
        } else {
          console.warn("⚠️ Unexpected policy data structure:", data);
        }
      } catch (err) {
        console.error("🚫 Failed to fetch policies:", err);
      }
    };
    fetchPolicies();
  }, [user]);

  // logs
  const fetchNotification = async () => {
    const agent = user || JSON.parse(localStorage.getItem("user"));
    if (!agent?.id) return console.warn("❌ Agent ID not found.");

    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/v1/notification/fetch-notification/${agent.id}`
    );
    const notification_list = await response.json();

    if (notification_list?.data) {
      setLogs(notification_list.data);
      setFilteredLogs(notification_list.data);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  // filtering
  useEffect(() => {
    let fl = logs;
    if (occasionFilter !== "All Occasions") {
      fl = fl.filter((log) => log.occasion === occasionFilter);
    }
    if (searchTerm.trim() !== "") {
      fl = fl.filter(
        (l) =>
          l.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          l.policyNumber?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (activeTab !== "All") {
      fl = fl.filter((l) => l.occasion === activeTab);
    }
    setFilteredLogs(fl);

    if (occasionFilter === "All Occasions") {
      let fc = customers;
      if (searchTerm.trim() !== "") {
        fc = fc.filter(
          (c) =>
            c.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            c.policyNumber?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      setFilteredCustomers(fc);
    }
  }, [searchTerm, occasionFilter, activeTab, logs, customers]);

  const handleClear = () => {
    setSearchTerm("");
    setOccasionFilter("All Occasions");
    setFilteredLogs(logs);
    setFilteredCustomers(customers);
  };

  const handleViewLog = (log) => {
    setSelectedLog(log);
    setShowLogModal(true);
    markAsRead(log.notificationId);
  };

  useEffect(() => markAllAsRead(), []);

  return (
    <div className="dashboard-layout notification-page-wrapper d-flex">
      <Sidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        unreadNotificationCount={unreadCount}
        onNotificationClick={markAllAsRead}
      />

      

      <div className="main-content p-4 w-100 notification-page">

        {/* Banner */} 
        <div className="top-banner shadow-sm mb-3">
          <div className="banner-inner p-2">
            <div className="banner-left">
              <span className="banner-icon">
                <i className="bi bi-megaphone" />
              </span>
              <div className="banner-copy">
                <h5 className="banner-title">Stay Connected with Your Customers!</h5>
                <p className="banner-subtitle">
                  Send warm wishes on their special days and festivals to strengthen your relationships.
                </p>
              </div>
            </div> 

            {/* <img
              src="/family-life-insurance-illustration.png"
              alt="Celebration"
              className="banner-illustration"
            /> */}
          </div>
        </div>

        {/* Filter/Search Card */}
<div className="card-shell filter-card mb-4">
  <div className="card-head">
    <div className="head-left">
      <span className="icon-pill xl"><i className="bi bi-funnel" /></span>
      <h6 className="headline">Advanced Search & Filters</h6>
    </div>
  </div>

  <form
    className="filter-row"
    onSubmit={(e) => {
      e.preventDefault();
      // UI-only "Apply"
    }}
  >
    {/* Search */}
    <div className="search-col">
      <label className="form-label sr-only">Search</label>
      <div className="search-wrap">
        <span className="search-tile" aria-hidden="true">
          <FaSearch />
        </span>
        <input
          type="text"
          className="form-control search-input"
          placeholder="Search by customer name or policy number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
    </div>

    {/* Occasion */}
    <div className="occasion-col">
      <label className="form-label sr-only">Occasion</label>
      <select
        className="form-select select-soft"
        value={occasionFilter}
        onChange={(e) => setOccasionFilter(e.target.value)}
      >
        <option>All Occasions</option>
        <option>Birthday</option>
        <option>Custom</option>
        <option>Policy Due</option>
      </select>
    </div>

    {/* Actions */}
    <div className="actions-col">
      <button type="submit" className="btn btn-apply">Apply</button>
      <button type="button" className="btn btn-clear" onClick={handleClear}>
        Clear
      </button>
    </div>
  </form>
  <small className="field-hint">
        Tip: Try typing a few letters of the customer’s name or a policy number.
      </small>
</div>

        {/* PolicyHolder */}
        {occasionFilter === "All Occasions" && (
          <div className="card-shell table-card">
            <div className="card-head">
              <div className="head-left">
                <span className="icon-pill"><i className="bi bi-people" /></span>
                <h6>PolicyHolder</h6>
                <span className="badge count-badge">{filteredCustomers.length}</span>
              </div>
            </div>

            <div className="table-wrap">
              <table className="table grid-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Policy Number</th>
                    <th>Contact</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length > 0 ? (
                    filteredCustomers.map((item) => (
                      <tr key={item._id}>
                        <td>
                          <div className="row-cell">
                            {/* <div className="chip-avatar">
                              {item.customerName?.charAt(0)?.toUpperCase()}
                            </div> */}
                            <div className="stack">
                              <strong>{item.customerName}</strong>
                              <small className="muted">{item.customerEmail}</small>
                            </div>
                          </div>
                        </td>
                        <td>{item.policyNumber}</td>
                        <td>
                          {/* <FaPhone className="me-1" /> */}
                          {item.customerPhone}
                        </td>
                        <td>
                          <button
                            className="btn btn-teal-soft btn-sm"
                            onClick={() => handleWishClick(item)}
                          >
                            Send Custom Messages
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">
                        <div className="empty-state">
                          <i className="bi bi-search" />
                          <p>No matching PolicyHolder records found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Notification Logs */}
        <div className="card-shell table-card mt-4">
          <div className="card-head">
            <div className="head-left">
              <span className="icon-pill"><i className="bi bi-journal-text" /></span>
              <h6>Notification Logs</h6>
            </div>
            <div className="head-right">
              <span className="current-date">
                {new Date().toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            </div>
          </div>

          <div className="table-wrap">
            <table className="table grid-table zebra align-middle">
              <thead>
                <tr>
                  <th>Name & Email</th>
                  <th>Policy Details</th>
                  <th>Policy No.</th>
                  <th>Contact No.</th>
                  <th>Occasion</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.length > 0 ? (
                  filteredLogs.map((log) => (
                    <tr key={log.notificationId}>
                      <td>
                        <div className="stack">
                          <strong>{log.customerName}</strong>
                          <small className="muted">{log.customerEmail}</small>
                        </div>
                      </td>
                      <td>
                        <div className="stack">
                          <strong>{log.company || "LIC India"}</strong>
                          <small className="muted">{log.policyType || "Jeevan Anand Plan"}</small>
                        </div>
                      </td>
                      <td>{log.policyNumber}</td>
                      <td>
                        <FaPhone className="me-1 text-danger" />
                        {log.customerPhone}
                      </td>
                      <td>
                        {log.occasion === "Birthday" && "🎂 Birthday"}
                        {log.occasion === "Policy Due" && "📅 Policy Due"}
                        {log.occasion === "Custom" && "✉️ Custom"}
                      </td>
                      <td>
                        <button
                          className="btn btn-teal-soft btn-sm"
                          onClick={() => handleViewLog(log)}
                        >
                          View Message
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="empty-state">
                        <i className="bi bi-inboxes" />
                        <p>No matching Notification Log records found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

       {/* Log View Modal */}
<Modal show={showLogModal} onHide={() => setShowLogModal(false)} centered className="view-log-modal">
  <Modal.Header closeButton>
    <Modal.Title>
      Message Details - <span className="text-dark">{selectedLog?.name}</span>
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="p-4" style={{ backgroundColor: '#F5FAFF' }}>
    <div className="message-box p-3 mb-4 rounded" style={{ backgroundColor: '#E9F9F5' }}>
      <strong className="d-block mb-2">Message Sent:</strong>
      <p className="text-muted m-0">{selectedLog?.message}</p>
    </div>
    <div className="row g-3">
      <div className="col-6">
        <p className="mb-1 text-muted small">Date & Time:</p>
        <p className="fw-semibold">{selectedLog?.createdAt}</p>
      </div>
      <div className="col-6">
        <p className="mb-1 text-muted small">Status:</p>
        <span className="badge status-badge px-3 py-2" style={{ backgroundColor: '#3EAEB1' }}>
          ✅ {selectedLog?.status}
        </span>
      </div>
      <div className="col-6">
        <p className="mb-1 text-muted small">Occasion:</p>
        <p className="fw-semibold">🎉 {selectedLog?.occasion}</p>
      </div>
      <div className="col-6">
        <p className="mb-1 text-muted small">Policy:</p>
        <p className="fw-semibold">{selectedLog?.policyNumber}</p>
      </div>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-ghost w-100 close-btn" onClick={() => setShowLogModal(false)}>
      Close
    </button>
  </Modal.Footer>
</Modal>

{/* Message Modal */}
<Modal show={showModal} onHide={() => setShowModal(false)} centered className="custom-message-modal">
  <Modal.Header closeButton className="border-0 pb-0">
    <Modal.Title className="w-100 text-center fw-bold ">
      ✉️ Send Personalized Message
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="px-4">
    <div className="mb-3 text-center">
      <p className="fw-semibold text-dark m-0">
        Message for <span className="">{selectedPerson?.customerName || "Customer"}</span>
      </p>
      <small className="text-muted">{selectedPerson?.customerPhone}</small>
    </div>

    <div className="form-group">
      <textarea  rows={5}
        className="form-control shadow-sm message-input"
        placeholder="Type your personalized message here..."
        value={wishMessage === "Send Custom message" ? "" : wishMessage}
        onChange={(e) => setWishMessage(e.target.value)}
        style={{ borderRadius: '10px', borderColor: '#3EAEB1' }}
      />
    </div>
  </Modal.Body>

  <Modal.Footer className="border-0 d-flex justify-content-between px-4">
    <Button variant="light" className="px-4 py-2 rounded-pill btn-ghost" onClick={() => setShowModal(false)}>
      <i className="bi bi-x-circle" /> Cancel
    </Button>
    <Button
      variant="dark"
      className="px-4 py-2 rounded-pill btn-teal"
      onClick={async () => {
        await handleSendMessage(selectedPerson, wishMessage);
        setShowModal(false);
      }}
    >
      <i className="bi bi-send" /> Send Message
    </Button>
  </Modal.Footer>
</Modal>

{/* Toast */}
<ToastContainer className="p-3" position="bottom-end">
  <Toast bg="light" show={showToast} delay={3000} autohide onClose={() => setShowToast(false)}>
    <Toast.Header closeButton={false}>
      <strong className="me-auto">Wish sent successfully! 🎉</strong>
    </Toast.Header>
    <Toast.Body>Message sent to <strong>{selectedPerson?.name}</strong></Toast.Body>
  </Toast>
</ToastContainer>

      </div>
    </div>
  );
};

export default NotificationPage;
